import { ChangeEvent, forwardRef, useContext } from 'react';
import { TenantContext } from '../../state/tenant-state';
import { Icons } from '../icons/icons';

type Props = {
  children: any;
  className?: string;
};

export const Tenant = (): JSX.Element => {
  const tenantContext = useContext(TenantContext);
  return <p className="tenant-name">{tenantContext.current?.name}</p>;
};

export const Title = (props: Props): JSX.Element => {
  return <div className="page-title">
    {props.children}
  </div>;
};

export const SubTitle = (props: Props): JSX.Element => {
  return <div className="page-description">{props.children}</div>;
};

type SearchProps = {
  name?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const Search = forwardRef((props: SearchProps, ref: any): JSX.Element => {
  return <div className="page-search">
    <Icons.Search />
    <input type="text" className="form-control" placeholder="Search" ref={ref} { ...props } />
  </div>;
});

export const Actions = (props: Props): JSX.Element => {
  return <div className={`header-actions justify-content-between d-flex ${props.className || ''}`}>{props.children}</div>;
};

export const Header = (props: Props): JSX.Element => {
  return <>{props.children}</>;
};
